import { render } from "./Detail.vue?vue&type=template&id=4cdb0a5c&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=4cdb0a5c&lang=less&scoped=true"
import "./Detail.vue?vue&type=style&index=1&id=4cdb0a5c&lang=less"

import exportComponent from "C:\\Users\\徐永哲\\Desktop\\银商北分远程办公系统\\wx-wl_full_II\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cdb0a5c"]])

export default __exports__